import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { CustomerGroupsListPage } from "@/modules/customers/pages/CustomerGroupsList.page";

export const Route = createFileRoute("/__authed/m/customers/groups")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_customer_groups")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: CustomerGroupsListPage,
});
